import { config } from '../../config';
import { useIsCategoryManagerSomewhere } from '../features/queries/meGetReportCategories';
import PermissionsGuard from './PermissionsGuard';
import React from 'react';

/**
 * Správa kategórií podnetov: celomestské `pruser:report-categories:manage`,
 * **alebo** správca aspoň jednej kategórie. Tá rola je na členstve v kategórii,
 * nie v tokene, takže sa na ňu `PermissionsGuard` sám opýtať nevie. Čo správca
 * na stránkach vidí a smie, rozhodujú stránky samy (len jeho kategórie, len
 * členovia) a tvrdú poistku drží API.
 */
const ReportCategoriesGuard: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const isCategoryManager = useIsCategoryManagerSomewhere();

  return (
    <PermissionsGuard
      hasSomePermission={[
        {
          client_id: config.CLIENT_ID,
          permission: 'pruser:report-categories:manage',
        },
      ]}
      orAllow={isCategoryManager}
      redirect='/'
    >
      {children}
    </PermissionsGuard>
  );
};

export default ReportCategoriesGuard;
